import React from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';

import Table from '../../../../../facturotopia/table/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const InformacionAduaneraList = ({ data, onDelete, onEdit }) => {

  const handleEdit = (item) => {
    onEdit(item);
  }

  const handleDelete = (item) => {
    onDelete(item);
  }

  return (
    <>
      <Table
        columns={ columns(handleEdit, handleDelete) }
        rowKey={ 'id' }
        data={ data }
      >
      </Table>
    </>
  )
}

const columns = (handleEdit, handleDelete) => [
  {
    align: 'center',
    key: '__',
    title: '',
    dataIndex: '__',
    render: (item) => {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={ handleEdit.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['far', 'edit'] } />
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={ handleDelete.bind(null, item)}
          >
            <FontAwesomeIcon icon={ ['fas', 'trash'] } />
          </Button>
        </>
      );
    }
  },
  {
    align: 'center',
    key: 'numero',
    title: 'Número',
    dataIndex: 'numero',
  },
  {
    align: 'center',
    key: 'fecha',
    title: 'Fecha',
    dataIndex: 'fecha',
    render: (value) => {
      return (
        <span>
          { moment(value.fecha).format('DD/MM/YYYY') }
        </span>
      )
    }
  },
  {
    align: 'center',
    key: 'aduana',
    title: 'Aduana',
    dataIndex: 'aduana',
  },
];

export default InformacionAduaneraList;